import { useCallback, useState } from "react";
import type { TicketStatus } from "@omnabase/shared";

/** What sending does, per person and workspace, remembered in this browser (DECISIONS 2026-09-26): the status a reply sets and
 *  where you go afterwards. Both sit in the sending line under the composer. */
export type AfterSend = "next" | "stay" | "list";
export type SendPrefs = { sendAs: TicketStatus; afterSend: AfterSend };
const DEFAULTS: SendPrefs = { sendAs: "pending", afterSend: "next" };
const key = (slug: string) => `ob-send:${slug}`;
const read = (slug: string): SendPrefs => { try { return { ...DEFAULTS, ...(JSON.parse(localStorage.getItem(key(slug)) ?? "{}") as Partial<SendPrefs>) }; } catch { return DEFAULTS; } };
export function useSendPrefs(slug: string): [SendPrefs, (patch: Partial<SendPrefs>) => void] {
  const [prefs, setPrefs] = useState<SendPrefs>(() => read(slug));
  const set = useCallback((patch: Partial<SendPrefs>) => { setPrefs((cur) => { const next = { ...cur, ...patch }; try { localStorage.setItem(key(slug), JSON.stringify(next)); } catch { /* private mode: lasts for this visit */ } return next; }); }, [slug]);
  return [prefs, set];
}
/** `{first}` is the customer's first name; an unknown placeholder is left alone so nobody sends a silent blank. */
export const fillReply = (text: string, vars: { first: string }) => text.replace(/\{first\}/g, vars.first);
/** Claim on reply (2026-10-12): the sending line's promise that this send makes the ticket the person's, only while nobody holds it and
 *  the workspace's "Assign on reply" is on (the server's rule); the same line under the composer, the phone's and the AI draft card */
